(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gp-nz-assembly-guides"] && !Shopify.designMode) return;
  try {
    function initialiseAssemblyGuides(root) {
  if (root.dataset.ready) return;
  const controls = root.querySelector('.gpa-controls');
  const status = root.querySelector('.gpa-result-status');
  const cards = [...root.querySelectorAll('.gpa-frame-card')];
  const frameButtons = [...root.querySelectorAll('[data-frame]')];
  const colourButtons = [...root.querySelectorAll('button[data-colour]')];
  const versionSelect = root.querySelector('#gpa-version');
  const search = root.querySelector('#gpa-search');
  const groups = [...root.querySelectorAll('.gpa-accessory-group')];
  const count = root.querySelector('#gpa-accessory-count');
  let selectedFrame = '', selectedColour = 'green', selectedVersion = 'current';
  const names = {"compact": "The Compact", "medium": "The Medium", "large": "The Large", "xl": "The XL", "large-cubby": "Large + Cubby House", "xl-cubby": "XL + Cubby House"};
  const normalise = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  const groupOpenStates = new Map();
  function updateGuides() {
    const earlier = selectedVersion === 'legacy';
    colourButtons.forEach(button => {button.disabled = earlier; button.setAttribute('aria-pressed',String(button.dataset.colour === selectedColour));});
    frameButtons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.frame === selectedFrame)));
    let visible = 0;
    cards.forEach(card => {
      card.hidden = card.dataset.model !== selectedFrame || card.dataset.version !== selectedVersion || (!earlier && card.dataset.colour !== selectedColour);
      if (!card.hidden) visible++;
    });
    status.textContent = !selectedFrame ? 'Choose your frame above to see its manuals.' : visible ? `${names[selectedFrame]} · ${earlier ? 'earlier box codes' : selectedColour === 'green' ? 'Green' : 'Blue'} — match the box codes below.` : 'No earlier box-code guide is listed for this model. Contact support to match your box codes.';
    const query = normalise(search.value);
    let matches = 0;
    groups.forEach(group => {
      group.hidden = !!query && !normalise(group.dataset.search).includes(query);
      if (!group.hidden) matches++;
      if (query) {
        if (!groupOpenStates.has(group)) groupOpenStates.set(group,group.open);
        group.open = !group.hidden;
      } else if (groupOpenStates.has(group)) {group.open = groupOpenStates.get(group);groupOpenStates.delete(group);}
    });
    count.textContent = `${matches} accessory ${matches === 1 ? 'group' : 'groups'}${query ? ' found' : ' available'}`;
    root.querySelector('.gpa-empty').hidden = matches !== 0;
  }
  function writeUrl(push) {
    const url = new URL(window.location.href);
    for (const [key,value] of [['frame',selectedFrame],['colour',selectedFrame ? selectedColour : ''],['version',selectedFrame ? selectedVersion : ''],['q',search.value]]) {
      if (value) url.searchParams.set(key,value); else url.searchParams.delete(key);
    }
    if (url.href !== window.location.href) history[push ? 'pushState' : 'replaceState'](null,'',url);
  }
  function readUrl() {
    const params = new URL(window.location.href).searchParams;
    selectedFrame = Object.hasOwn(names,params.get('frame')) ? params.get('frame') : '';
    selectedColour = params.get('colour') === 'blue' ? 'blue' : 'green';
    selectedVersion = params.get('version') === 'legacy' ? 'legacy' : 'current';
    if (selectedVersion === 'legacy') selectedColour = 'blue';
    versionSelect.value = selectedVersion;
    search.value = params.get('q') || '';
    updateGuides();
  }
  frameButtons.forEach(button => button.addEventListener('click',()=> {selectedFrame=button.dataset.frame;updateGuides();writeUrl(true);}));
  colourButtons.forEach(button => button.addEventListener('click',()=> {selectedColour=button.dataset.colour;updateGuides();writeUrl(true);}));
  versionSelect.addEventListener('change',()=> {selectedVersion=versionSelect.value;if(selectedVersion==='legacy')selectedColour='blue';updateGuides();writeUrl(true);});
  search.addEventListener('input',()=> {updateGuides();writeUrl(false);});
  window.addEventListener('popstate',readUrl);
  readUrl();
  controls.hidden=false;
  root.querySelector('.gpa-search').hidden=false;
  root.dataset.ready='true';
}
function loadAssemblyGuides() {document.querySelectorAll('[data-assembly-guides]').forEach(initialiseAssemblyGuides);}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',loadAssemblyGuides);else loadAssemblyGuides();
document.addEventListener('shopify:section:load',loadAssemblyGuides);
  } catch(e) { console.error(e); }
})();

})();
